export default "__VITE_ASSET__DDaUMWIS__"